<template>
  <div class="calculator">
    <h1>Return Rate Calculator</h1>
    <form @submit.prevent="calculateRate">
      <div class="form-group">
        <label for="currentAge">Current Age</label>
        <input type="number" v-model="currentAge" id="currentAge" required />
      </div>
      <div class="form-group">
        <label for="annualPayment">Annual Payment</label>
        <input type="number" v-model="annualPayment" id="annualPayment" required />
      </div>
      <div class="form-group">
        <label for="paymentYears">Payment Years</label>
        <input type="number" v-model="paymentYears" id="paymentYears" required />
      </div>
      <div class="form-group">
        <label for="targetAge">Target Age</label>
        <input type="number" v-model="targetAge" id="targetAge" required />
      </div>
      <div class="form-group">
        <label for="targetReturnValue">Target Return Value</label>
        <input type="number" v-model="targetReturnValue" id="targetReturnValue" required />
      </div>
      <button type="submit" class="calculate-button">Calculate Return Rate</button>
    </form>
  </div>
</template>

<script>
export default {
  computed: {
    currentAge: {
      get() {
        return this.$store.state.currentAge;
      },
      set(value) {
        this.$store.commit('setCurrentAge', value);
      },
    },
    annualPayment: {
      get() {
        return this.$store.state.annualPayment;
      },
      set(value) {
        this.$store.commit('setAnnualPayment', value);
      },
    },
    paymentYears: {
      get() {
        return this.$store.state.paymentYears;
      },
      set(value) {
        this.$store.commit('setPaymentYears', value);
      },
    },
    targetAge: {
      get() {
        return this.$store.state.targetAge;
      },
      set(value) {
        this.$store.commit('setTargetAge', value);
      },
    },
    targetReturnValue: {
      get() {
        return this.$store.state.targetReturnValue;
      },
      set(value) {
        this.$store.commit('setTargetReturnValue', value);
      },
    },
  },
  methods: {
    presentValueSinglePayment(payment, rate, year) {
      return payment / (1 + rate) ** year;
    },
    calculateTotalPresentValue(annualPayment, paymentYears, rate) {
      const presentValues = [];
      for (let year = 0; year < paymentYears; year++) {
        presentValues.push(this.presentValueSinglePayment(annualPayment, rate, year));
      }
      return presentValues.reduce((acc, val) => acc + val, 0);
    },
    findDiscountRate(targetValue, annualPayment, paymentYears, duration, tolerance = 1, maxIterations = 1000) {
      let lowRate = 0.0;
      let highRate = 1.0;
      let iterations = 0;
      while (iterations < maxIterations) {
        const midRate = (lowRate + highRate) / 2;
        const totalPresentValue = this.calculateTotalPresentValue(annualPayment, paymentYears, midRate);
        const presentValueOfReturn = this.presentValueSinglePayment(targetValue, midRate, duration);
        const difference = presentValueOfReturn - totalPresentValue;
        if (Math.abs(difference) < tolerance) {
          return {
            discountRate: midRate,
            totalPresentValue,
            presentValueOfReturn,
          };
        }
        if (difference > 0) {
          lowRate = midRate;
        } else {
          highRate = midRate;
        }
        iterations++;
      }
      return null;
    },
    calculateRate() {
      const duration = this.targetAge - this.currentAge;
      const result = this.findDiscountRate(
        this.targetReturnValue,
        this.annualPayment,
        this.paymentYears,
        duration
      );
      this.$store.commit('setResult', result);
      // Navigate to the results page and pass the result as a query parameter
      this.$router.push({ name: 'MyResult', query: { result: JSON.stringify(result) } });
    },
  },
};
</script>

<style scoped>
.calculator {
  padding: 10px;
  /* max-width: 480px; */
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

h1 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-top: 5px;
  /* margin-bottom: 5px; */
}

input {
  width: 90%;
  margin: 5px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.calculate-button {
  width: 90%;
  margin-top: 20px;
  padding: 15px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.calculate-button:hover {
  background-color: #0056b3;
}
</style>